import chance from "@/modules/base/services/chance";
import {injectable, inject} from "inversify";
import {StaffMember} from "@/modules/staff/entity";
import {MarketValueCalculator} from "@/modules/staff/services/MarketValueCalculator";

@injectable()
export abstract class AbstractStaffMemberFactory {
  constructor(
    @inject(MarketValueCalculator) private marketValueCalculator: MarketValueCalculator
  ) {}

  protected abstract make(): StaffMember;

  public async generate() {
    const member = this.make();

    member.name = `${chance.first()} ${chance.last()}`;
    member.age = chance.integer({min: 25, max: 60});
    member.skill = chance.integer({min: 1, max: 100});
    member.wage = chance.integer({min: 10, max: 20});
    member.marketValue = chance.integer({min: 1000, max: 2000});

    member.patience = chance.integer({min: 1, max: 100});
    member.greediness = chance.integer({min: 1, max: 100});
    member.resentfulness = chance.integer({min: 1, max: 100});
    member.baseMonthlyPrice = chance.integer({min: 1000, max: 2000});
    member.baseOncePrice = chance.integer({min: 1000, max: 2000});
    member.marketValue = await this.marketValueCalculator.calculate(member);

    await member.save();

    console.debug(`Generate staff member ${member.constructor.name}: ${member.name}`);

    return member;
  }
}